import { AuthenticationService } from './services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UsuarioService } from './backoffice/services/usuario.service';

import { IdiomaService } from './services/idioma.service';

import { Observable } from 'rxjs';
import { Usuario } from './backoffice/models/usuario';
import { SIDEBAR_MENU, SidebarMenuItem, SidebarMenuModule } from './shared/sidebar-menu/sidebar-menu.config';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ UsuarioService, IdiomaService]
})
export class AppComponent implements OnInit {

  public t: any;
  public textos$: Observable<any>;
  public logueado: boolean;
  public collapsed: boolean = false;
  public usuario: Usuario;
  public menu: SidebarMenuModule[] = SIDEBAR_MENU;
  public insertado = false; // para usar insertado en SAPB1 cambiar a true
  public mobileSidebarOpen = false;

  public moduleTitle: string = 'Nombre del módulo';

  public get isFullBleedRoute(): boolean {
    const currentRoute = this._router.url.split('?')[0];
    return currentRoute === '/changepass' || currentRoute === '/inicio';
  }

  constructor(
    private _idiomaSvc: IdiomaService,
    public _authSvc: AuthenticationService,
    private _router: Router,
    private _usuarioSvc: UsuarioService,
    private _activeRoute: ActivatedRoute,
  ){
  }

  ngOnInit(): void {
    console.log('app.ngOnInit');
    console.log('this._activeRoute.snapshot.queryParamMap', this._activeRoute.snapshot.queryParamMap);
    this.textos$ = this._idiomaSvc.getTextos$();
    this.textos$.subscribe(texto => this.t = texto);

    this._authSvc.cambioUsuario$.subscribe(usuario => {
      let {token, ...currentUsuario} = usuario || {};
      console.log('usuario logueado', currentUsuario);
      this.logueado = usuario != null;
      if (!this.logueado) {
        console.log('revisar', this._activeRoute.snapshot.queryParams);
        // this._router.navigate(['/']);
      }
      else {
        this.actualizarDatosUsuario();
      }
    });

    this._activeRoute.queryParams.subscribe((params) => {
      console.log('query params', params);
    });

    this._activeRoute.queryParamMap
      .subscribe((params) => {
        let {token, ...currentUsuario} = this._authSvc.usuarioActual || {};
        console.log('app queryParamMap', params);
        console.log('usuario', currentUsuario);

        const jwt = params.get('jwt');
        const destino = params.get('destino');
        if (jwt) {
          if (this._authSvc.usuarioActual == null) {
            if (!this._authSvc.validarNuevoJwt(jwt)) {
              return;
            }

            console.log('jwt validado');
          }

          this.insertado = true;
          this._router.navigate([destino]).then((a) => console.log('nav ok', a)).catch((a) => console.log('nav fail', a));
      }
        /*
        const destino = params.get('destino');

        if (destino) {
          this.insertado = true;
          console.log('Modo Business One');
        }
        */
      }
    );

    let {token, ...currentUsuario} = this?._authSvc.usuarioActual  || {};
    console.log('recién iniciado', currentUsuario);

    this.actualizarDatosUsuario();
    this.configurarEstadoMenuSidebar();
    this.configurarCierreMobileSidebar();
  }

   configurarEstadoMenuSidebar(): void {
    $(document)
      .off('show.bs.dropdown.sidebar-menu-state')
      .on('show.bs.dropdown.sidebar-menu-state', '.small-sidebar .dropright', (event) => {
        const $secciones = $(event.currentTarget).find('.dropdown-menu details.menu-section');

        if (!$secciones.length) {
          return;
        }

        $secciones.prop('open', false);
        $secciones.first().prop('open', true);
      });
  }

   configurarCierreMobileSidebar(): void {
    $(document)
      .off('click.sidebar-mobile-close')
      .on('click.sidebar-mobile-close', '.small-sidebar .dropdown-menu a, #sidebar .collapse-links a', () => {
        this.closeMobileSidebar();
      });
   }

   actualizarDatosUsuario(): void {
      const idusuario = this._authSvc?.usuarioActual?.id;
      if (idusuario) {
        this._usuarioSvc.getById(idusuario).subscribe(
          usuario => {
            this.usuario = usuario;
          }
        );
      }
      else {
        this.usuario = null;
      }
   }

  // --- Helpers del menú lateral ---
  // Comparten la fuente única de verdad (SIDEBAR_MENU) con el buscador de
  // accesos. Para agregar/quitar accesos o cambiar permisos, editar SOLO
  // ./shared/sidebar-menu/sidebar-menu.config.ts

  /** Gate de permisos (OR). Sin permisos definidos => visible. */
  puedeVer(permisos?: string[]): boolean {
    if (!permisos || permisos.length === 0) {
      return true;
    }
    return this._authSvc.tienePermiso(...permisos);
  }

  /** Gate combinado del ítem: `permissions` (OR) y `permissionsAll` (AND). */
  puedeVerItem(item: SidebarMenuItem): boolean {
    if (!this.puedeVer(item.permissions)) {
      return false;
    }
    return (item.permissionsAll || []).every(permiso => this._authSvc.tienePermiso(permiso));
  }

  /** Traducción con respaldo. */
  texto(clave: string, respaldo: string = ''): string {
    return this.t && this.t[clave] ? this.t[clave] : respaldo;
  }

  /** Etiqueta del ítem, agregando el sufijo cuando corresponde. */
  etiquetaItem(item: SidebarMenuItem): string {
    const label = this.texto(item.labelKey, item.fallbackLabel);
    if (!item.labelSuffixKey) {
      return label;
    }
    return `${label} - ${this.texto(item.labelSuffixKey, item.fallbackLabelSuffix || '')}`;
  }

  onLogout(): void {
    this._authSvc.logout();
  }

  onSidebarSearchResultClick(): void {
    this.closeMobileSidebar();
  }

  openMobileSidebarForSearch(): void {
    if (window.innerWidth >= 768 || this.mobileSidebarOpen) {
      return;
    }

    this.toggleMobileSidebar();
  }

  closeMobileSidebar(): void {
    if (window.innerWidth >= 768 || !this.mobileSidebarOpen) {
      return;
    }

    this.mobileSidebarOpen = false;
    $('#small-sidebar').removeClass('d-none');
    $('#sidebar').removeClass('sidebar');
    $('#sidebar').addClass('sidebar-collapsed');
  }

  collapseSidebar(){
    if (window.innerWidth < 768 && this.mobileSidebarOpen) {
      this.closeMobileSidebar();
      return;
    }

    $('#small-sidebar').toggleClass('d-none');
    $('#sidebar').toggleClass('sidebar');
    $('#sidebar').toggleClass('sidebar-collapsed');

  }

  toggleMobileSidebar(): void {
    if (window.innerWidth >= 768) {
      return;
    }

    if (this.mobileSidebarOpen) {
      this.closeMobileSidebar();
      return;
    }

    this.mobileSidebarOpen = true;
    $('#small-sidebar').addClass('d-none');
    $('#sidebar').removeClass('sidebar-collapsed');
    $('#sidebar').addClass('sidebar');
  }

}
